import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <blockquote>
      <p parentName="blockquote">{`This library was built by the community and is not maintained by the PostHog core team.`}</p>
    </blockquote>
    <p>{`The package can be installed by adding `}<inlineCode parentName="p">{`posthog`}</inlineCode>{` to your list of dependencies in `}<inlineCode parentName="p">{`mix.exs`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-elixir"
      }}>{`def deps do
  [
    {:posthog, "~> 0.1"}
  ]
end
`}</code></pre>
    <h3 {...{
      "id": "configuration"
    }}>{`Configuration`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-elixir"
      }}>{`config :posthog,
  api_url: "<ph_instance_address>",
  api_key: "<ph_project_api_key>"
`}</code></pre>
    <p>{`Optionally, you can pass in a `}<inlineCode parentName="p">{`:json_library`}</inlineCode>{` key. The default JSON parser is Jason.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      